import { zPoListProposalsData, zPoProposalViewFilters } from '@repo/sdk/zod'

// The fields the grid can sort on, as the backend declares them: the URL
// schema and the column sort keys both read them.
export const PROPOSAL_SORT_FIELDS =
	zPoListProposalsData.shape.body.shape.sort.unwrap().shape.field.enum

// The grid's search as the backend accepts it: the URL schema and the search
// field both keep to its maximum length.
export const PROPOSAL_SEARCH = zPoProposalViewFilters.shape.search.unwrap()

// URL state -> the filters of the view on screen (single-value pickers become
// one-element arrays on the wire). The grid adds the run id; «accetta questa
// vista» sends them as they are.
export function viewFilters(params: {
	search: string
	publisher?: number
	distributor?: string
	tipologia?: 'elementari' | 'medie' | 'superiori' | 'varia'
	review?: 'pending' | 'accepted' | 'corrected'
}) {
	return {
		search: params.search || undefined,
		publisherIds:
			params.publisher === undefined ? undefined : [params.publisher],
		distributorNames: params.distributor ? [params.distributor] : undefined,
		schoolTypes: params.tipologia ? [params.tipologia] : undefined,
		reviewStatus: params.review ? [params.review] : undefined
	}
}
